import { defineComponent, onMounted, onUnmounted, ref } from 'vue';

export default defineComponent({
  name: 'NotificationPage',
  setup: () => {
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      initialDataTable();
    });

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      const dt = datatable.value as HTMLTableElement;
      if (!$.fn.dataTable.isDataTable(dt)) {
        dtInstance.value = $(dt).DataTable({
          language: {
            emptyTable: 'ไม่พบข้อมูล',
            info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
            infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
            infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
            lengthMenu: 'แสดงข้อมูล _MENU_',
            paginate: {
              next: 'ถัดไป',
              previous: 'ก่อนหน้า',
              first: 'First',
              last: 'Last'
            },
            search: 'ค้นหา:',
            zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
          }
        });
      }
    };

    return {
      datatable,
    };
  }
});
